import * as React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Grid from "@mui/material/Grid";
import FindWordsQuery from "./FindWordsQuery";
import GroupList from "./GroupList";
import WordsList from "./WordsList";
import SelectLeitner from "../SelectLeitner/SelectLeitner"
import TransferWords from "../TransferWords/TransferWords"
import { ToastContainer } from "react-toastify";

const InfoAddWithGroup = () => {
  return (
    <>
      <Typography >مراحل کار:</Typography>
      <Typography sx={{ color: "green" }}>1- نوع انتخاب : بر اساس لغت</Typography>
      <Typography>2-فیلتر لغات درخواستی</Typography>
      <Typography>3- انتخاب لغات</Typography>
      <Typography>4- انتخاب لایتنر</Typography>
      <Typography>5- انتقال لغات به لایتنر</Typography>
    </>
  )
}

const nextStepError = (step) => {
  if (step == 3) return (
    <>
      <Typography sx={{ color: "red" }}>در مرحله قبل باید روی جستجو کلیک کنید</Typography>
      <Typography >با کلیک بر روی دکمه برگشت می توانید به مرحله قبل برگدید</Typography>
    </>
  )
  if (step == 4) return (
    <>
      <Typography sx={{ color: "red" }}>در مرحله قبل باید حداقل یک لغت را انتخاب کنید</Typography>
      <Typography >با کلیک بر روی دکمه برگشت می توانید به مرحله قبل برگدید</Typography>
    </>
  )
  if (step == 5) return (
    <>
      <Typography sx={{ color: "red" }}>در مرحله قبل باید یک لایتنر را انتخاب کنید</Typography>
      <Typography >با کلیک بر روی دکمه برگشت می توانید به مرحله قبل برگدید</Typography>
    </>
  )
}
export default function AddwithWord(props) {
  const { activeStep, handleNext, handleBack } = props;
  const [findQuery, setFindQuery] = React.useState(false);
  // const [selectedGroup, setSelectedGroup] = React.useState(false);
  const [selectedWords, setSelectedWords] = React.useState([]);
  const [selectedLeitner, setSelectedLeitner] = React.useState(false);
  const [transferDone, setTransferDone] = React.useState(false);

  const handleTransferDone = (state) => {
    setTransferDone(state);
  };

  const handleFindQuery = (data) => {
    setSelectedWords([])
    setFindQuery(data);
  };


  const handleSelectWords = (words) => {
    setSelectedWords(words);
  };

  const handleSelectedLeitner = (leitner) => {
    handleTransferDone(false)
    setSelectedLeitner(leitner);
  };
  const steps = [
    {
      label: "انتقال بر اساس فیلتر لغات",
      description: <InfoAddWithGroup />,
    },
    {
      label: "فلیتر لغات",
      description: (
        <>
          <FindWordsQuery handleFindQuery={handleFindQuery} />
        </>
      ),
    },
    {
      label: "انتخاب لغات",
      description: findQuery ? <WordsList findQuery={findQuery} selectedWords={selectedWords} handleSelectWords={handleSelectWords} /> : nextStepError(3),
    },
    {
      label: "انتخاب لایتنر",
      description: selectedWords.length > 0 ? <SelectLeitner selectedLeitner={selectedLeitner} handleSelectedLeitner={handleSelectedLeitner} /> : nextStepError(4),

    },
    {
      label: "انتقال لغات",
      description: (selectedLeitner && selectedWords.length > 0) || transferDone ? <TransferWords handleSelectWords={handleSelectWords} selectedLeitner={selectedLeitner} selectedWords={selectedWords} handleTransferDone={handleTransferDone} /> : nextStepError(5),

    },
  ];

  const maxSteps = steps.length;

  return (
    <Grid sx={{ width: "100%", height: "75vh" }}>
      <Paper
        square
        elevation={0}
        sx={{
          alignItems: "center",
          textAlign: "center",
          height: 50,
          pt: 1,
          bgcolor: "background.default",
        }}
      >
        <Typography>{steps[activeStep].label}</Typography>
      </Paper>
      <Box
        sx={{
          height: "73%",
          width: "100%",
          p: 1,
          textAlign: "center",
          color: (theme) => theme.palette.reverse.dark,
        }}
      >
        {steps[activeStep].description}
      </Box>
      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            variant="contained"
            disabled={activeStep === maxSteps - 1}
            sx={{ m: 0, p: 0 }}
          >
            ادامه
            <KeyboardArrowLeft />
          </Button>
        }
        backButton={
          <Button
            variant="contained"
            size="small"
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{ m: 0, p: 0 }}
          >
            <KeyboardArrowRight />
            برگشت
          </Button>
        }
      />
    </Grid>
  );
}
